editCarrouselElementController.$inject = [
  '$scope',
  '$translate',
  '$element',
  '$mdDialog',
  'MediasFactory',
  'AlertingFactory',
  'elementData',
  'parentElementData',
  'elementView',
  'context'];
export function editCarrouselElementController(
  $scope,
  $translate,
  $element,
  $mdDialog,
  MediasFactory,
  AlertingFactory,
  elementData,
  parentElementData,
  elementView,
  context) {
  $scope.ok = submit;
  $scope.cancel = cancel;
  $scope.deleteItem = deleteItem;
  $scope.removePicture = removePicture;
  $scope.isElementValid = isElementValid;
  $scope.getTextMaxLength = getTextMaxLength;
  $scope.getSubtitleLength = getSubtitleLength;

  let subtitleElementController;

  init();

  function init() {
    $scope.elementData = elementData;
    $scope.elementView = elementView;
    $scope.site = context.site;
    $scope.companyId = context.companyId;

    $scope.fileNames = {};

    $scope.canHavePicture = elementView.getConfigurationOption('carrousel-element-can-have-picture');
    $scope.hasMediaHeight = elementView.getConfigurationOption('carrousel-element-has-media-height');
    $scope.mediaHeightRequired = elementView.getConfigurationOption('carrousel-element-media-height-required');
    $scope.canHaveTitle = elementView.getConfigurationOption('carrousel-element-can-have-title');
    $scope.titleRequired = elementView.getConfigurationOption('carrousel-element-title-required');
    $scope.canHaveSubtitle = elementView.getConfigurationOption('carrousel-element-can-have-subtitle');
    $scope.subtitleRequired = elementView.getConfigurationOption('carrousel-element-subtitle-required');
    $scope.canHaveDefaultAction = elementView.getConfigurationOption('carrousel-element-can-have-default-action');
    $scope.titleMaxLength = elementView.getConfigurationOption('carrousel-element-title-max-length');
    $scope.subtitleMaxLength = elementView.getConfigurationOption('carrousel-element-subtitle-max-length');
    $scope.canHaveBackgroundColor = elementView.getConfigurationOption('carrousel-element-can-have-background-color');
    $scope.loading = false;
    $scope.pictureFile = null;
    $scope.mediaUrl = '';
    $scope.textErrorMessage = '';

    initMediaHeightDropdownItems();

    updateMediaUrls();
    $scope.$watch('fileNames.picture', function (newFile) {
      if (newFile) {
        uploadImage(newFile);
      }
    });
  }

  function initMediaHeightDropdownItems() {
    $scope.mediaHeightDropdownItems = [{
      id: 'short',
      label: $translate.instant(elementView.resolveTranslationKey('carrousel_element_edition_media_height_short'))
    }, {
      id: 'medium',
      label: $translate.instant(elementView.resolveTranslationKey('carrousel_element_edition_media_height_medium'))
    }, {
      id: 'tall',
      label: $translate.instant(elementView.resolveTranslationKey('carrousel_element_edition_media_height_tall'))
    }];
  }


  function submit() {
    delete $scope.elementData.temporaryElement;
    $mdDialog.hide({ type: 'ok', data: $scope.elementData });
  }

  function cancel() {
    if ($scope.elementData.temporaryElement) {
      $mdDialog.hide({ type: 'delete' });
    } else {
      $mdDialog.cancel();
    }
  }

  function deleteItem() {
    $mdDialog.hide({ type: 'delete' });
  }

  function removePicture() {
    delete $scope.elementData.pictureId;
    updateMediaUrls();
  }

  function updateMediaUrls() {
    if (typeof elementData.pictureId === 'number') {
      $scope.mediaUrl = MediasFactory.pictureUrl($scope.companyId, elementData.pictureId);
    } else {
      $scope.mediaUrl = '';
    }
  }

  function uploadImage(file) {
    $scope.loading = true;
    MediasFactory.upload2($scope.companyId, $scope.site.id, 'image', file,
      response => {
        elementData.pictureId = response.data.media_id;
        $scope.loading = false;
        updateMediaUrls();
      },
      response => {
        $scope.loading = false;
        AlertingFactory.error(response.data.error);
      });
  }

  function isElementValid() {
    let maxLength = 0;

    // avoid calling $element.find multiple times, because isElementValid is called permantly by the template
    if (!subtitleElementController) {
      subtitleElementController = $element.find("[name='subtitle']").controller('ngModel');
    }

    // if an image is present, no matter the number of slides, and text too long
    if (!!$scope.mediaUrl && subtitleElementController.$error.maxlength) {
      maxLength = elementView.getConfigurationOption('carrousel-element-subtitle-max-length-with-image');
      $scope.textErrorMessage = $translate.instant(
        elementView.resolveTranslationKey('too_long_img_carrousel_message'),
        { value: maxLength }
      );
      return false;
    }
    // if more than one slide, and text too long
    else if (parentElementData.elements.length > 1 && subtitleElementController.$error.maxlength) {
      maxLength = elementView.getConfigurationOption('carrousel-element-subtitle-max-length-several-slide');
      $scope.textErrorMessage = $translate.instant(
        elementView.resolveTranslationKey('too_long_slide_carrousel_message'),
        { value: maxLength }
      );
      return false;
    } else {
      $scope.textErrorMessage = $translate.instant(elementView.resolveTranslationKey('invalid_carrousel_message'), {
        value: maxLength
      });
      const validationFunction = elementView.getConfigurationOption('carrousel-element-validation-function');
      return validationFunction(elementData);
    }
  }

  /**
   * Return a different length depending :
   * - the presence of an image or not
   * - the number of elements in the carrousel
   */
  function getTextMaxLength() {
    let key = '';

    if (parentElementData.elements.length === 1) {
      key = !!$scope.mediaUrl
        ? 'carrousel-element-subtitle-max-length-with-image'
        : 'carrousel-element-subtitle-max-length-one-slide';
    } else {
      key = !!$scope.mediaUrl
        ? 'carrousel-element-subtitle-max-length-with-image'
        : 'carrousel-element-subtitle-max-length-several-slide';
    }

    return elementView.getConfigurationOption(key);
  }

  /**
   * If the string is longer than the maxLength, then elementData.subtitle is undefined, so we can't have the length of the subtitle.
   * It happens when changing the maxLength on the fly.
   */
  function getSubtitleLength() {
    // avoid calling $element.find multiple times, because getSubtitleLength is called permantly by the template
    if (!subtitleElementController) {
      subtitleElementController = $element.find("[name='subtitle']").controller('ngModel');
    }

    // empty string : $viewValue = undefined
    if (!subtitleElementController.$viewValue) {
      return 0;
    }
    return subtitleElementController.$viewValue.length;
  }
}
